export type TotaisDesempenho = {
  concluidosHoje: number;
  paraHoje?: number;
  atrasados?: number;
  paraAgendar?: number;
  alerta?: number;
};

export function calcularDesempenho(totais: TotaisDesempenho): number {
  const concluidos = Math.max(totais.concluidosHoje ?? 0, 0);
  const pendentes = calcularTotalFazeres(totais) - concluidos;
  const total = concluidos + pendentes;

  return total > 0 ? Math.round((concluidos / total) * 100) : 100;
}

export function calcularTotalFazeres(totais: TotaisDesempenho): number {
  const concluidos = Math.max(totais.concluidosHoje ?? 0, 0);
  const alerta = Math.max(totais.alerta ?? 0, 0);
  const agendar = Math.max(totais.paraAgendar ?? 0, 0);
  return (
    concluidos +
    Math.max(totais.paraHoje ?? 0, 0) +
    Math.max(totais.atrasados ?? 0, 0) +
    agendar +
    alerta
  );
}
